/* =================================================================
   bn-offer.js  —  Aurora Sleep offer widget (asset version)

   Lives in your theme as assets/bn-offer.js so the EComposer
   section file stays small. The section only needs a mount div
   and a script tag; all the weight is here.

   INSTALL
   1. Shopify admin -> Online Store -> Themes -> ... -> Edit code
   2. Assets -> Add a new asset -> Create blank file
      Name it:  bn-offer.js
   3. Paste this entire file in. Save.
   4. In EComposer, in BOTH product boxes, replace your Custom
      HTML/Liquid content with just:

        <div data-bno-mount></div>
        {{ 'bn-offer.js' | asset_url | script_tag }}

   5. Fill in the two variant IDs in CONFIG below.
   6. Set up the Shopify automatic discounts (see DISCOUNTS note).

   ------------------------------------------------------------------
   DISCOUNTS — NOT HANDLED HERE
   This adds QUANTITY. Shopify sets price. Without automatic
   discounts a 2-pack charges 2 x $29.99 = $59.98, not $49.98.

     Admin -> Discounts -> Create -> Amount off products -> Automatic
     Applies to: Blissful Night (30 bags)
       "2-pack"  min quantity 2  ->  $5.00 off each
       "3-pack"  min quantity 3  ->  $7.49 off each
   ------------------------------------------------------------------
================================================================= */

(function () {
  'use strict';

  /* ========================= CONFIG ========================= */

  var FULL = {
    variantId: '49065665757338',        // 30-bag VARIANT id
    unitCents: 2999,
    nights: 30
  };

  var SAMPLER = {
    variantId: '49062608863386',        // 10-bag VARIANT id
    priceCents: 1299,
    nights: 10
  };

  // eachCents is DISPLAY ONLY. Keep in sync with your discounts.
  var TIERS = [
    { qty: 1, title: 'Try 1 ', sub: 'Lasts 30 days',            eachCents: 2999, badge: '',            perks: [] },
    { qty: 2, title: 'Try 2 ', sub: '60 days of restful sleep', eachCents: 2499, badge: 'Best value',  perks: ['Free shipping', 'Save $10.00'] },
    { qty: 3, title: 'Try 3 ', sub: '90 day full sleep reset',  eachCents: 2250, badge: 'Best seller', alt: true, perks: ['Free shipping', 'Save $22.47', 'Lowest per night'] }
  ];

  var DEFAULT_SIZE = 'full';
  var DEFAULT_QTY = 2;
  var SHOW_PER_NIGHT = true;
  var CTA_TEXT = 'Try it now, risk-free';
  var HIDE_THEME_BUTTON = true;
  var THEME_BUTTON_MATCH = 'try it now';

  /* ============================================================ */

  if (window.__bnoLoaded) return;
  window.__bnoLoaded = true;

  if (!FULL.variantId || !SAMPLER.variantId) {
    console.error('[bno] set FULL.variantId and SAMPLER.variantId in bn-offer.js');
    return;
  }

  var CSS = [
    '.bno{--a:#a8ded3;--a2:#7fd6b4;--ink:#0b1020;--tx:#eef2f7;',
    '--mu:rgba(238,242,247,.56);--pnl:#171f30;--cd:rgba(255,255,255,.035);',
    '--cdon:rgba(168,222,211,.11);--ln:rgba(255,255,255,.1);',
    '--cta:26px;--ttl:17px;--sb:13px;--pr:21px;--now:30px;',
    'display:block;margin:22px 0;color:var(--tx)}',
    '.bno[hidden]{display:none}.bno *,.bno *::before,.bno *::after{box-sizing:border-box}',
    '.bno__in{position:relative;padding:20px;border-radius:20px;',
    'background:radial-gradient(120% 90% at 50% -20%,rgba(168,222,211,.14),transparent 62%),var(--pnl);',
    'border:1px solid rgba(168,222,211,.3);',
    'box-shadow:0 0 0 1px rgba(0,0,0,.35),0 22px 50px -18px rgba(0,0,0,.75),0 0 44px -22px rgba(168,222,211,.5)}',
    '.bno__hd{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:13px}',
    '.bno__eb{font-size:11.5px;font-weight:800;letter-spacing:.13em;text-transform:uppercase;color:var(--a)}',
    '.bno__gr{font-size:11.5px;color:var(--mu)}',
    '.bno__sz{display:grid;grid-template-columns:1fr 1fr;gap:8px;padding:6px;',
    'background:rgba(0,0,0,.28);border-radius:13px;margin-bottom:15px}',
    '.bno__szb{display:flex;flex-direction:column;gap:1px;padding:11px 12px;border:0;border-radius:9px;',
    'background:transparent;color:var(--mu);font:inherit;text-align:left;cursor:pointer;',
    'transition:background .18s,color .18s}',
    '.bno__szb:focus-visible{outline:2px solid var(--a);outline-offset:2px}',
    '.bno__szb.on{background:rgba(168,222,211,.16);color:var(--tx)}',
    '.bno__szn{font-size:15px;font-weight:700;line-height:1.2}.bno__szs{font-size:11.5px}',
    '.bno__ts{display:flex;flex-direction:column;gap:10px}.bno__ts[hidden]{display:none}',
    '.bno__t{position:relative;display:grid;grid-template-columns:21px 1fr auto;align-items:center;gap:12px;',
    'width:100%;padding:16px 15px;border:1.5px solid var(--ln);border-radius:14px;background:var(--cd);',
    'color:inherit;font:inherit;text-align:left;cursor:pointer;transition:border-color .2s,background .2s,transform .12s}',
    '.bno__t:hover{border-color:rgba(168,222,211,.45)}.bno__t:active{transform:scale(.995)}',
    '.bno__t:focus-visible{outline:2px solid var(--a);outline-offset:3px}',
    '.bno__t.on{border-color:var(--a);background:var(--cdon);box-shadow:0 0 0 1px var(--a) inset}',
    '.bno__d{position:relative;width:20px;height:20px;border:2px solid rgba(255,255,255,.3);',
    'border-radius:50%;transition:border-color .2s}.bno__t.on .bno__d{border-color:var(--a)}',
    '.bno__d::after{content:"";position:absolute;inset:4px;border-radius:50%;background:var(--a);',
    'transform:scale(0);transition:transform .2s cubic-bezier(.3,1.4,.5,1)}',
    '.bno__t.on .bno__d::after{transform:scale(1)}',
    '.bno__bd{min-width:0}.bno__ttl{font-size:var(--ttl);font-weight:700;line-height:1.25}',
    '.bno__sb{margin-top:2px;font-size:var(--sb);color:var(--mu);line-height:1.35}',
    '.bno__pr{text-align:right;white-space:nowrap}',
    '.bno__ea{font-size:var(--pr);font-weight:800;line-height:1.15;letter-spacing:-.02em}',
    '.bno__eal{font-size:12px;font-weight:500;color:var(--mu)}',
    '.bno__st{display:block;margin-top:1px;font-size:13px;color:var(--mu);text-decoration:line-through}',
    '.bno__bg{position:absolute;top:-9px;left:14px;padding:4px 10px;border-radius:99px;background:var(--a);',
    'color:var(--ink);font-size:10px;font-weight:800;letter-spacing:.07em;text-transform:uppercase;line-height:1}',
    '.bno__bg--alt{background:var(--a2)}.bno__t.on .bno__bg{display:none}',
    '.bno__pk{grid-column:1/-1;display:none;flex-wrap:wrap;gap:5px 14px;margin-top:2px;padding-top:11px;',
    'border-top:1px solid rgba(168,222,211,.2);font-size:12.5px}',
    '.bno__t.on .bno__pk{display:flex}',
    '.bno__pki::before{content:"\\2713";margin-right:5px;color:var(--a);font-weight:700}',
    '.bno__sm{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:17px 16px;',
    'border:1.5px solid var(--a);border-radius:14px;background:var(--cdon)}',
    '.bno__sm[hidden]{display:none}',
    '.bno__smb{display:flex;flex-direction:column;gap:3px;min-width:0}',
    '.bno__smt{font-size:var(--ttl);font-weight:700}',
    '.bno__sms{font-size:var(--sb);color:var(--mu);line-height:1.35}',
    '.bno__smp{font-size:25px;font-weight:800;letter-spacing:-.02em;white-space:nowrap}',
    '.bno__tot{display:flex;align-items:baseline;justify-content:space-between;gap:14px;margin:16px 2px 13px}',
    '.bno__totl{font-size:13.5px;color:var(--mu)}',
    '.bno__totf{display:inline-flex;align-items:baseline;gap:9px}',
    '.bno__was{font-size:15px;color:var(--mu);text-decoration:line-through}.bno__was:empty{display:none}',
    '.bno__now{font-size:var(--now);font-weight:800;letter-spacing:-.02em}',
    '.bno__cta{display:block;width:100%;padding:19px 20px;border:0;border-radius:12px;background:var(--a);',
    'color:var(--ink);font-family:"Ancizar Serif",Georgia,serif;font-size:var(--cta);font-weight:700;',
    'line-height:1.2;cursor:pointer;box-shadow:0 10px 26px -12px rgba(168,222,211,.75);',
    'transition:opacity .15s,transform .12s}',
    '.bno__cta:hover{opacity:.93}.bno__cta:active{transform:scale(.99)}',
    '.bno__cta:focus-visible{outline:2px solid #fff;outline-offset:3px}',
    '.bno__cta[disabled]{opacity:.6;cursor:default;box-shadow:none}',
    '.bno__msg{margin-top:11px;font-size:13.5px;line-height:1.45;text-align:center}',
    '.bno__msg[hidden]{display:none}.bno__msg.err{color:#ffb0b0}',
    '.bno__tr{display:flex;flex-wrap:wrap;justify-content:center;gap:6px 16px;margin-top:13px;',
    'font-size:11.5px;color:var(--mu)}',
    '.bno__tr span::before{content:"\\2713";margin-right:4px;color:var(--a)}',
    '@media(max-width:480px){.bno{--ttl:15.5px;--pr:19px;--cta:21px;--now:26px}',
    '.bno__in{padding:16px 14px;border-radius:17px}',
    '.bno__t{padding:14px 13px;gap:10px;grid-template-columns:19px 1fr auto}',
    '.bno__hd{flex-direction:column;gap:3px}}',
    '@media(prefers-reduced-motion:reduce){.bno__t,.bno__d,.bno__d::after,.bno__cta,.bno__szb{transition:none}}',
    '.bno-hide{display:none!important}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('bno-css')) return;
    var s = document.createElement('style');
    s.id = 'bno-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function openDrawer(data) {
    var opened = false;
    try {
      if (typeof window.aovCartDrawerUpdateAndOpen === 'function') {
        window.aovCartDrawerUpdateAndOpen(); opened = true;
      } else if (typeof window.aovCartDrawerOpen === 'function') {
        if (typeof window.aovCartDrawerUpdate === 'function') window.aovCartDrawerUpdate();
        window.aovCartDrawerOpen(); opened = true;
      }
    } catch (e) { console.warn('[bno] AOV drawer failed', e); }

    if (!opened) {
      var d = document.querySelector('cart-drawer');
      if (d) {
        try {
          if (typeof d.renderContents === 'function' && data && data.sections) {
            d.renderContents(data); opened = true;
          } else if (typeof d.open === 'function') { d.open(); opened = true; }
        } catch (e2) { console.warn('[bno] cart-drawer failed', e2); }
      }
    }

    ['cart:refresh', 'cart:build', 'cart-drawer:open'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: data }));
    });

    return opened;
  }

  function hideThemeButtons() {
    if (!HIDE_THEME_BUTTON) return;
    document.querySelectorAll('button[name="add"],.ecom-product-single__add-to-cart--submit')
      .forEach(function (b) {
        var l = (b.getAttribute('data-text-add-cart') || '').toLowerCase();
        if (l.indexOf(THEME_BUTTON_MATCH) === -1) return;
        (b.closest('.ecom-product-single__add-to-cart-wrapper') ||
         b.closest('.ecom-block') || b).classList.add('bno-hide');
      });
  }

  var MARKUP =
    '<div class="bno__in">' +
      '<div class="bno__hd"><span class="bno__eb">Choose your pack</span>' +
      '<span class="bno__gr">30-day money-back guarantee</span></div>' +
      '<div class="bno__sz" role="radiogroup" aria-label="Choose your size">' +
        '<button type="button" class="bno__szb" data-sz="sampler" role="radio" aria-checked="false">' +
        '<span class="bno__szn">10 tea bags</span><span class="bno__szs">Try it for 10 nights</span></button>' +
        '<button type="button" class="bno__szb on" data-sz="full" role="radio" aria-checked="true">' +
        '<span class="bno__szn">30 tea bags</span><span class="bno__szs">A full month of sleep</span></button>' +
      '</div>' +
      '<div class="bno__ts" data-ts role="radiogroup" aria-label="Choose your pack"></div>' +
      '<div class="bno__sm" data-sm hidden>' +
        '<span class="bno__smb"><span class="bno__smt">10-night starter</span>' +
        '<span class="bno__sms">The same blend, in a smaller pack.</span></span>' +
        '<span class="bno__smp" data-smp></span>' +
      '</div>' +
      '<div class="bno__tot"><span class="bno__totl" data-lbl></span>' +
      '<span class="bno__totf"><span class="bno__was" data-was></span>' +
      '<span class="bno__now" data-now></span></span></div>' +
      '<button type="button" class="bno__cta" data-add><span data-ctatxt></span></button>' +
      '<div class="bno__msg" data-msg hidden></div>' +
      '<div class="bno__tr"><span>Free shipping over $50</span><span>3\u20134 day delivery</span>' +
      '<span>Melatonin-free</span></div>' +
    '</div>';

  function build(mount) {
    if (mount.__bno) return;
    mount.__bno = true;

    var root = document.createElement('div');
    root.className = 'bno';
    root.innerHTML = MARKUP;
    mount.appendChild(root);

    var ts = root.querySelector('[data-ts]'), sm = root.querySelector('[data-sm]');
    var smp = root.querySelector('[data-smp]'), lbl = root.querySelector('[data-lbl]');
    var was = root.querySelector('[data-was]'), now = root.querySelector('[data-now]');
    var add = root.querySelector('[data-add]'), ctatxt = root.querySelector('[data-ctatxt]');
    var msg = root.querySelector('[data-msg]');
    var szs = [].slice.call(root.querySelectorAll('[data-sz]'));

    var size = DEFAULT_SIZE, qty = DEFAULT_QTY;
    smp.textContent = money(SAMPLER.priceCents);
    ctatxt.textContent = CTA_TEXT;

    TIERS.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bno__t'; b.dataset.qty = t.qty;
      b.setAttribute('role', 'radio');
      var sub = t.sub;
      if (SHOW_PER_NIGHT) sub += ' \u00b7 $' + (t.eachCents / FULL.nights / 100).toFixed(2) + ' per night';
      b.innerHTML =
        (t.badge ? '<span class="bno__bg' + (t.alt ? ' bno__bg--alt' : '') + '">' + t.badge + '</span>' : '') +
        '<span class="bno__d" aria-hidden="true"></span>' +
        '<span class="bno__bd"><span class="bno__ttl">' + t.title + '</span>' +
        '<span class="bno__sb">' + sub + '</span></span>' +
        '<span class="bno__pr"><span class="bno__ea">' + money(t.eachCents) +
        '<span class="bno__eal">/each</span></span>' +
        (t.eachCents < FULL.unitCents ? '<span class="bno__st">' + money(FULL.unitCents) + '/each</span>' : '') +
        '</span>' +
        (t.perks.length ? '<span class="bno__pk">' + t.perks.map(function (p) {
          return '<span class="bno__pki">' + p + '</span>'; }).join('') + '</span>' : '');
      b.addEventListener('click', function () { qty = t.qty; render(); });
      ts.appendChild(b);
    });

    szs.forEach(function (b) {
      b.addEventListener('click', function () { size = b.dataset.sz; render(); });
    });

    ts.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var i = TIERS.map(function (t) { return t.qty; }).indexOf(qty);
      var st = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
      qty = TIERS[(i + st + TIERS.length) % TIERS.length].qty;
      render();
      ts.querySelector('[data-qty="' + qty + '"]').focus();
    });

    function render() {
      var s = (size === 'sampler');
      szs.forEach(function (b) {
        var on = b.dataset.sz === size;
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      ts.hidden = s; sm.hidden = !s;

      if (s) {
        lbl.textContent = '10 tea bags \u00b7 ' + SAMPLER.nights + ' nights';
        was.textContent = '';
        now.textContent = money(SAMPLER.priceCents);
      } else {
        var t = TIERS.filter(function (x) { return x.qty === qty; })[0] || TIERS[0];
        [].slice.call(ts.children).forEach(function (b) {
          var on = Number(b.dataset.qty) === t.qty;
          b.classList.toggle('on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var tot = t.eachCents * t.qty, full = FULL.unitCents * t.qty;
        lbl.textContent = t.qty + (t.qty === 1 ? ' pouch' : ' pouches') +
                          ' \u00b7 ' + (t.qty * FULL.nights) + ' nights';
        was.textContent = full > tot ? money(full) : '';
        now.textContent = money(tot);
      }
      msg.hidden = true; msg.className = 'bno__msg';
    }

    add.addEventListener('click', function () {
      var id = (size === 'sampler') ? SAMPLER.variantId : FULL.variantId;
      var q = (size === 'sampler') ? 1 : qty;

      add.disabled = true; ctatxt.textContent = 'Adding\u2026';
      msg.hidden = true; msg.className = 'bno__msg';

      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: q }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok) throw new Error(d.description || d.message || 'Add to cart failed');
            return d;
          });
        })
        .then(function (d) {
          ctatxt.textContent = CTA_TEXT; add.disabled = false;
          if (!openDrawer(d)) {
            msg.innerHTML = 'Added to your cart. <a href="/cart" style="color:inherit;text-decoration:underline">View cart</a>';
            msg.hidden = false;
          }
        })
        .catch(function (err) {
          ctatxt.textContent = CTA_TEXT; add.disabled = false;
          msg.textContent = (err && err.message) || 'Could not add to cart. Please try again.';
          msg.className = 'bno__msg err'; msg.hidden = false;
          console.error('[bno]', err);
        });
    });

    render();
  }

  function boot() {
    injectCSS();
    document.querySelectorAll('[data-bno-mount]').forEach(build);
    hideThemeButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  setTimeout(boot, 700);
  setTimeout(boot, 2000);
})();


(function () {
  'use strict';
 
  /* ========================= CONFIG ========================= */
 
  // Buttons whose label contains any of these become scroll links.
  // Matched against data-text-add-cart, case-insensitive.
  var SCROLL_CTAS = ['sleep through the whole night'];
 
  // Pixels of breathing room above the widget when it scrolls into
  // view. Increase if you have a sticky header covering it.
  var SCROLL_OFFSET = 90;
 
  // Briefly highlight the widget on arrival so it's obvious where
  // the button sent you.
  var FLASH_ON_ARRIVE = true;
 
  /* ============================================================ */
 
  if (window.__bnCtaLoaded) return;
  window.__bnCtaLoaded = true;
 
  var CSS = [
    /* Hover for the widget's own primary button */
    '.bno__cta{transition:transform .18s cubic-bezier(.2,.9,.3,1.2),',
    'box-shadow .18s ease,filter .18s ease,opacity .15s ease!important}',
    '.bno__cta:hover{transform:translateY(-2px);filter:brightness(1.05);',
    'box-shadow:0 16px 34px -12px rgba(168,222,211,.85)}',
    '.bno__cta:active{transform:translateY(0) scale(.99)}',
 
    /* Hover for the EComposer secondary CTAs */
    '.bn-scroll-cta{position:relative;overflow:hidden;',
    'transition:transform .18s cubic-bezier(.2,.9,.3,1.2),',
    'box-shadow .18s ease,filter .18s ease!important;cursor:pointer}',
    '.bn-scroll-cta:hover{transform:translateY(-2px);filter:brightness(1.05);',
    'box-shadow:0 16px 34px -12px rgba(168,222,211,.7)}',
    '.bn-scroll-cta:active{transform:translateY(0) scale(.99)}',
 
    /* Sheen sweep on hover */
    '.bn-scroll-cta::after{content:"";position:absolute;top:0;left:-60%;width:45%;height:100%;',
    'background:linear-gradient(100deg,transparent,rgba(255,255,255,.42),transparent);',
    'transform:skewX(-18deg);transition:left .55s ease;pointer-events:none}',
    '.bn-scroll-cta:hover::after{left:120%}',
 
    /* Arrival flash on the widget */
    '@keyframes bnoFlash{0%{box-shadow:0 0 0 0 rgba(168,222,211,.55)}',
    '70%{box-shadow:0 0 0 16px rgba(168,222,211,0)}',
    '100%{box-shadow:0 0 0 0 rgba(168,222,211,0)}}',
    '.bno__in.bno-flash{animation:bnoFlash 1.15s ease-out 1}',
 
    '@media(prefers-reduced-motion:reduce){',
    '.bno__cta,.bn-scroll-cta{transition:none!important}',
    '.bn-scroll-cta::after{display:none}',
    '.bno__in.bno-flash{animation:none}}'
  ].join('');
 
  function injectCSS() {
    if (document.getElementById('bn-cta-css')) return;
    var s = document.createElement('style');
    s.id = 'bn-cta-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
 
  // The widget that's actually on screen — desktop and mobile each
  // have their own copy and only one is visible.
  function visibleWidget() {
    var all = [].slice.call(document.querySelectorAll('.bno'));
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) return all[i];
    }
    return null;
  }
 
  function scrollToOffer() {
    var w = visibleWidget();
    if (!w) { window.location.href = '/products/sleep-tea'; return; }
 
    var y = w.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
    var reduce = window.matchMedia &&
                 window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
 
    if (FLASH_ON_ARRIVE && !reduce) {
      var panel = w.querySelector('.bno__in');
      if (panel) {
        setTimeout(function () {
          panel.classList.remove('bno-flash');
          void panel.offsetWidth;          // restart the animation
          panel.classList.add('bno-flash');
          setTimeout(function () { panel.classList.remove('bno-flash'); }, 1400);
        }, 480);
      }
    }
  }
 
  function wire() {
    document.querySelectorAll('button[name="add"],.ecom-product-single__add-to-cart--submit')
      .forEach(function (btn) {
        if (btn.dataset.bnCta) return;
 
        var label = (btn.getAttribute('data-text-add-cart') || btn.textContent || '').toLowerCase();
        var isScroll = SCROLL_CTAS.some(function (m) {
          return label.indexOf(m.toLowerCase()) !== -1;
        });
        if (!isScroll) return;
 
        btn.dataset.bnCta = '1';
        btn.classList.add('bn-scroll-cta');
 
        // Stop the form submit before the theme's own handler sees
        // it — capture phase, so this runs first.
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          scrollToOffer();
        }, true);
 
        // A submit button inside a form will still submit on Enter.
        btn.type = 'button';
      });
  }
 
  function boot() { injectCSS(); wire(); }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  setTimeout(boot, 700);
  setTimeout(boot, 2000);
})();